<template>
  <v-app id="login">
    <app-snack-bar />
    <v-main class="login-page">
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm4
            md4
            lg3
          >
            <v-card
              class="app-card app-card--without-border pa-3 login-page-card"
              max-width="365"
            >
              <v-form
                ref="form"
                lazy-validation
                class="login-page-form app-form"
                @submit.prevent="onSubmit"
              >
                <v-card-text class="pt-0 pb-0">
                  <div class="layout column align-center">
                    <img
                      src="../../assets/images/logo.svg"
                      alt="Logo Sistransce"
                      class="login-page-form__logo"
                    >
                    <h5 class="login-page-form__title mb-5">
                      Digite sua nova senha
                    </h5>
                  </div>
                  <v-text-field
                    v-model="formModel.password"
                    prepend-inner-icon="lock"
                    label="Senha *"
                    type="password"
                    outlined
                    :rules="[rules.required]"
                    color="#067B26"
                  />
                  <v-text-field
                    v-model="formModel.passwordConfirmation"
                    prepend-inner-icon="lock"
                    label="Confirmar a Senha *"
                    type="password"
                    outlined
                    :rules="[rules.required]"
                    color="#067B26"
                  />
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn
                    block
                    x-large
                    depressed
                    type="submit"
                    color="#067B26"
                    class="login-page-form__submit white--text"
                    :loading="loading"
                  >
                    Continuar
                  </v-btn>               
                </v-card-actions>

                <router-link
                  :to="{name: 'login'}"
                  title="Voltar login"
                  class="back"
                >
                  Voltar login
                </router-link>
                <section
                  v-if="loading"
                  class="loading"
                />
              </v-form>
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                bottom
                color="#067B26"
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import Vue from 'vue';
  import GlobalStore from '@/store/modules/global';
  import AppSnackBar from '@/components/AppSnackBar';
  import AuthenticationService from '@/services/authentication.service';


  import { APP_NAME } from '@/commons/config';

  export default Vue.extend({
    components: {
      AppSnackBar
    },
    data: () => ({
      loading: false,
      appName: APP_NAME,
      formModel: {
        password: '',
        passwordConfirmation: '',
      },
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },
      error: '',
      returnUrl: '',
      token: null
    }),
    created() {
      this.returnUrl = this.$route.query.returnUrl || '/';
    },
    mounted() {
      this.verifyToken()
    },
    methods: {
      onSubmit() {
        const isValid = this.$refs.form.validate();

        if (isValid) {
          this.loading = true;
          
          AuthenticationService.resetPassword(this.buildResetData()).subscribe({
            next: () => {
              this.loading = false;
              GlobalStore.setSnackBar({
                timeout: 5000,
                show: true,
                message: 'Senha alterada com sucesso! Efetue o login para continuar.',
                type: 'success'
              });
              this.$router.push({ name: 'login' });
            },
            error: () => {
              this.loading = false;              
            }
          });
        }
      },

      verifyToken() {
        const { query } = this.$route
        if(query.hasOwnProperty('token')) {
          const { token } = query
          this.token = token
        } 
      },

      buildResetData() {
        const { password, passwordConfirmation } = this.formModel;
          
        return {
          user: {
            token: this.token,
            password: password,
            password_confirmation: passwordConfirmation
          }          
        }
      }
    }
  });
</script>

<style scoped lang="scss">
#login {
  .login-page {
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../../assets/images/background.png") #f1f1f1;
    background-repeat: no-repeat;
    background-position: right bottom;
    background-attachment: fixed;
    background-size: contain;

    &-card {
      padding: 30px;
      margin: auto;
    }

    &-form {
      margin-top: 10px;
      margin-bottom: 10px !important;

      &__logo {
        width: 82%;
        margin: 0px auto 20px auto;
        display: table;
      }

      &__title {
        text-align: center;
        font-weight: 400;
        margin: 5px auto;
      }

      &__appname {
        margin: 0px;
        font-weight: bold !important;
        font-size: 20px !important;
      }
    }
    .text-right {
      display: table;
      margin-right: 0;
      width: 100%;
    }
  }
}
.back{
  margin: 10px auto;
  display: table;
  text-transform: capitalize;
}
</style>
